module.exports = __webpack_public_path__ + "static/media/credit-system.f3187a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productService/images/credit-system.png
// module id = 157
// module chunks = 0